/* assets/product-form.js — ES5-only, legacy-safe */

(function () {
  // Capture the incoming Shopify variant deep-link before any theme logic can
  // rewrite the URL. This is intentionally kept outside the ProductForm
  // constructor so the proven cart/COD behavior remains untouched.
  var CELIATI_INITIAL_VARIANT_ID = (function () {
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    return m ? String(m[1]) : '';
  })();

  // Constructor
  function ProductForm(root) {
    this.root = root;
    this.form = root.querySelector('form');
    if (!this.form) { console.error('❌ <form> not found inside <product-form>'); return; }

    this.shopifyIdInput = this.form.querySelector('input[name="id"]');

    // Section id (matches ids used in your templates)
    this.sectionId = root.getAttribute('data-section-id') || ((this.form.id || '').replace(/^product-form-/, ''));

    // The variant-selects block
    this.variantSelects = document.querySelector('variant-selects[data-section="' + this.sectionId + '"]');
    if (!this.variantSelects) { this._retryInit(); return; }

    // Parse variants JSON (prefer inline script on the picker, fallback to #product-variants-json)
    var jsonEl = this.variantSelects.querySelector('[data-variants]');
    try {
      if (!jsonEl) {
        var fb = document.getElementById('product-variants-json');
        this.variants = fb ? JSON.parse(fb.textContent) : [];
      } else {
        this.variants = JSON.parse(jsonEl.textContent);
      }
    } catch (e) {
      console.error('❌ Error parsing variants JSON', e);
      this.variants = [];
    }

    // Fixed option indices: option1 = size, option2 = color
    this.sizeIndex = 1;
    this.colorIndex = 2;

    // Wire events
    var self = this;
    this.variantSelects.addEventListener('change', function () { self.handleVariantUpdate(); });
    this.form.addEventListener('submit', function (evt) { self.handleSubmit(evt); });

    // Track the initial auto-selected color separately from deliberate customer choices.
    // On the customer's FIRST deliberate color click, replace the automatic/default
    // color with the clicked color. After that, normal multi-select behavior applies.
    this._initialAutoColorValue = null;
    this._customerHasChosenColor = false;

    // Bind directly to inputs (old WebViews don’t bubble reliably)
    var inputs = this.variantSelects.querySelectorAll('input');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].classList && inputs[i].classList.contains('color-swatch-input')) {
        (function (input) {
          input.addEventListener('click', function () {
            if (!self._customerHasChosenColor) {
              var allColors = self.variantSelects.querySelectorAll('.color-swatch-input');

              // Clicking the already-auto-selected color should not leave the product
              // with zero colors selected. Treat it as the customer's chosen color.
              if (self._initialAutoColorValue && input.value === self._initialAutoColorValue && !input.checked) {
                input.checked = true;
              } else {
                for (var c = 0; c < allColors.length; c++) {
                  if (allColors[c] !== input) allColors[c].checked = false;
                }
                input.checked = true;
              }

              self._customerHasChosenColor = true;
            }
          });
        })(inputs[i]);
      }
      inputs[i].addEventListener('change', this.handleVariantUpdate.bind(this));
      inputs[i].addEventListener('click',  this.handleVariantUpdate.bind(this));
      inputs[i].addEventListener('input',  this.handleVariantUpdate.bind(this));
    }

    // ---- Auto-select: first SIZE that has stock, then first COLOR for that size
    var sizeInputs = this.variantSelects.querySelectorAll('input[name="size"]');
    var selectedSize = null;
    if (sizeInputs.length) {
      for (var s = 0; s < sizeInputs.length; s++) {
        var sz = sizeInputs[s].value, hasAvail = false;
        for (var v1 = 0; v1 < this.variants.length; v1++) {
          var vv1 = this.variants[v1];
          if (vv1['option' + this.sizeIndex] === sz && vv1.available) { hasAvail = true; break; }
        }
        if (hasAvail) { sizeInputs[s].checked = true; selectedSize = sz; break; }
      }
      if (!selectedSize) { sizeInputs[0].checked = true; selectedSize = sizeInputs[0].value; }
    }

    if (selectedSize) {
      var colorInputsAll = this.variantSelects.querySelectorAll('.color-swatch-input');
      var chosenColorInput = null;
      for (var v2 = 0; v2 < this.variants.length; v2++) {
        var vv2 = this.variants[v2];
        if (vv2['option' + this.sizeIndex] === selectedSize && vv2.available) {
          var targetColor = vv2['option' + this.colorIndex];
          for (var i2 = 0; i2 < colorInputsAll.length; i2++) {
            if (colorInputsAll[i2].value === targetColor) { chosenColorInput = colorInputsAll[i2]; break; }
          }
          if (chosenColorInput) break;
        }
      }
      if (chosenColorInput && !chosenColorInput.checked) { chosenColorInput.checked = true; }
      if (chosenColorInput) this._initialAutoColorValue = chosenColorInput.value;
    }

    // Initial compute (availability, price, COD payload)
    this.handleVariantUpdate();
  }

  ProductForm.prototype._retryInit = function () {
    var self = this;
    this._retryCount = (this._retryCount || 0) + 1;
    if (this._retryCount < 10) {
      setTimeout(function () { self.variantSelects = document.querySelector('variant-selects[data-section="' + self.sectionId + '"]'); if (self.variantSelects) self._retryFinish(); else self._retryInit(); }, 120);
    } else {
      console.warn('variant-selects not found after retries; giving up');
    }
  };

  ProductForm.prototype._retryFinish = function () {
    // Re-run constructor from the current instance’s root
    ProductForm.call(this, this.root);
  };

  ProductForm.prototype.handleVariantUpdate = function () {
    var sizeInput = this.variantSelects.querySelector('input[name="size"]:checked');
    if (!sizeInput) sizeInput = this.variantSelects.querySelector('input[type="radio"]:checked');
    var colorInputs = this.variantSelects.querySelectorAll('.color-swatch-input:checked');
    if (!colorInputs.length) colorInputs = this.variantSelects.querySelectorAll('input[type="checkbox"]:checked');

    var selectedSize = sizeInput ? sizeInput.value : null;

    // Selected colors → array
    var selectedColors = [];
    for (var i = 0; i < colorInputs.length; i++) selectedColors.push(colorInputs[i].value);

    // Disable only truly-unavailable colors for the chosen size
    var allColorInputs = this.variantSelects.querySelectorAll('.color-swatch-input');
    if (!selectedSize) {
      for (var k = 0; k < allColorInputs.length; k++) {
        allColorInputs[k].disabled = false;
        var lbl0 = allColorInputs[k].nextElementSibling;
        if (lbl0) lbl0.classList.remove('disabled');
      }
    } else {
      for (var j = 0; j < allColorInputs.length; j++) {
        var input = allColorInputs[j];
        var color = input.value;

        // find matching variant
        var match = null;
        for (var v = 0; v < this.variants.length; v++) {
          var vv = this.variants[v];
          if (vv['option' + this.sizeIndex] === selectedSize &&
              vv['option' + this.colorIndex] === color) { match = vv; break; }
        }

        var label = input.nextElementSibling;
        var isAvailable = !!(match && match.available);
        input.disabled = !isAvailable;
        if (label) { if (!isAvailable) label.classList.add('disabled'); else label.classList.remove('disabled'); }
      }
    }

    // Require one of each before enabling submit
    var submitBtn = this.form.querySelector('[type="submit"]');
    if (submitBtn) {
      if (!selectedSize || selectedColors.length === 0) { submitBtn.disabled = true; }
      else {
        // also disable if any chosen variant is unavailable
        var anyUnavailable = false;
        for (var u = 0; u < selectedColors.length; u++) {
          var mv = null;
          for (var mv_i = 0; mv_i < this.variants.length; mv_i++) {
            var vv2 = this.variants[mv_i];
            if (vv2['option' + this.sizeIndex] === selectedSize &&
                vv2['option' + this.colorIndex] === selectedColors[u]) { mv = vv2; break; }
          }
          if (!mv || !mv.available) { anyUnavailable = true; break; }
        }
        submitBtn.disabled = anyUnavailable;
      }
    }

    // Build matched variants
    var matched = [];
    for (var sc = 0; sc < selectedColors.length; sc++) {
      var c = selectedColors[sc], mv2 = null;
      for (var i2 = 0; i2 < this.variants.length; i2++) {
        var vv3 = this.variants[i2];
        if (vv3['option' + this.sizeIndex] === selectedSize &&
            vv3['option' + this.colorIndex] === c) { mv2 = vv3; break; }
      }
      if (mv2) matched.push(mv2);
    }

    // Sum price + pack discount (same rules you had)
    var totalCents = 0;
    for (var m = 0; m < matched.length; m++) totalCents += matched[m].price;

    var discount = 0;
    if (window.packDiscountEnabled) {
      var qty = matched.length;
      if (qty === 2) discount = 0.05;
      else if (qty >= 3) discount = 0.10;
    }
    var discountedCents = Math.round(totalCents * (1 - discount));

    // Render price
    var priceEl = document.getElementById('price-' + this.sectionId);
    if (priceEl) {
      if (window.Shopify && Shopify.formatMoney) {
        priceEl.innerHTML = Shopify.formatMoney(discountedCents);
      } else {
        var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) ? (' ' + Shopify.currency.active) : '';
        priceEl.innerText = (discountedCents / 100).toFixed(2) + currency;
      }
    }

    // Update hidden Shopify ID to first matched (Shopify requires an id)
    var first = matched.length ? matched[0] : null;
    if (this.shopifyIdInput && first) this.shopifyIdInput.value = first.id;

    // Pass full array to COD popup
    var items = [];
    for (var mm = 0; mm < matched.length; mm++) items.push({ id: matched[mm].id, quantity: 1 });
    var codBtn = this.root.querySelector('.es-popup-button-product');
    if (codBtn) codBtn.setAttribute('data-items', JSON.stringify(items));
  };

  ProductForm.prototype.handleSubmit = function (evt) {
    evt.preventDefault();

    var submitBtn = this.form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    // Collect current size + colors
    var sizeEl = this.variantSelects.querySelector('input[name="size"]:checked');
    var size = sizeEl ? sizeEl.value : '';

    var colorsNode = this.variantSelects.querySelectorAll('.color-swatch-input:checked');
    var colors = [];
    for (var i = 0; i < colorsNode.length; i++) colors.push(colorsNode[i].value);

    // Build line items
    var items = [];
    for (var c = 0; c < colors.length; c++) {
      var color = colors[c];
      for (var v = 0; v < this.variants.length; v++) {
        var vv = this.variants[v];
        if (vv['option' + this.sizeIndex] === size && vv['option' + this.colorIndex] === color) {
          items.push({ id: vv.id, quantity: 1 });
          break;
        }
      }
    }

    // Max compatibility: XHR to /cart/add.js
    var addUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js';
    var payload = JSON.stringify({ items: items });
    var self = this;
    var req = new XMLHttpRequest();
    req.open('POST', addUrl, true);
    req.setRequestHeader('Content-Type', 'application/json');
    req.onreadystatechange = function () {
      if (req.readyState === 4) {
        if (req.status >= 200 && req.status < 300) {
          var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
          window.location.href = root + 'cart';
        } else {
          alert('Erreur lors de l’ajout au panier.');
          if (submitBtn) submitBtn.disabled = false;
        }
      }
    };
    req.send(payload);
  };

  // Apply a requested ?variant=ID after the legacy initializer has completed.
  // This keeps the long-tested ProductForm/cart/COD path intact while making
  // carousel deep-links deterministic.
  function applyInitialDeepLink(instance) {
    if (!CELIATI_INITIAL_VARIANT_ID || !instance || !instance.variantSelects || !instance.variants) return;

    var target = null;
    for (var i = 0; i < instance.variants.length; i++) {
      if (String(instance.variants[i].id) === CELIATI_INITIAL_VARIANT_ID) {
        target = instance.variants[i];
        break;
      }
    }
    if (!target) return;

    var wantedSize = target['option' + instance.sizeIndex];
    var wantedColor = target['option' + instance.colorIndex];
    var sizeInputs = instance.variantSelects.querySelectorAll('input[name="size"]');
    var colorInputs = instance.variantSelects.querySelectorAll('.color-swatch-input');
    var sizeFound = false, colorFound = false;

    for (var s = 0; s < sizeInputs.length; s++) {
      var useSize = sizeInputs[s].value === wantedSize;
      sizeInputs[s].checked = useSize;
      if (useSize) sizeFound = true;
    }
    for (var c = 0; c < colorInputs.length; c++) {
      var useColor = colorInputs[c].value === wantedColor;
      colorInputs[c].checked = useColor;
      if (useColor) colorFound = true;
    }

    if (!sizeFound || !colorFound) return;

    // Make the deep-linked concept the initial selection, not a deliberate
    // multi-select click. The customer's first later color choice still
    // replaces this initial concept exactly as before.
    instance._initialAutoColorValue = wantedColor;
    instance._customerHasChosenColor = false;
    instance.handleVariantUpdate();

    if (instance.shopifyIdInput) instance.shopifyIdInput.value = String(target.id);

    // Preserve pathname, locale and all non-variant query parameters.
    try {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', String(target.id));
      window.history.replaceState({}, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  }

  // Boot on DOM ready (works even without customElements)
  function boot() {
    var roots = document.querySelectorAll('product-form');
    for (var i = 0; i < roots.length; i++) {
      // Avoid double init
      if (!roots[i].__pfInstance) {
        roots[i].__pfInstance = new ProductForm(roots[i]);
        applyInitialDeepLink(roots[i].__pfInstance);
      }
    }
  }
  document.addEventListener('DOMContentLoaded', boot);
  // When sections re-render in theme editor or via AJAX
  document.addEventListener('shopify:section:load', boot);

  // Small helper: prevent default on COD anchor if present (matches your old code)
  document.addEventListener('DOMContentLoaded', function () {
    var esBtn = document.getElementById('es-popup-button');
    if (!esBtn) return;
    esBtn.addEventListener('click', function (e) { e.preventDefault(); });
  });
})();
